import { render, staticRenderFns } from "./CollectionBackPerformanceZuzhang.vue?vue&type=template&id=32b366fb&scoped=true&"
import script from "./CollectionBackPerformanceZuzhang.vue?vue&type=script&lang=js&"
export * from "./CollectionBackPerformanceZuzhang.vue?vue&type=script&lang=js&"
import style0 from "./CollectionBackPerformanceZuzhang.vue?vue&type=style&index=0&id=32b366fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b366fb",
  null
  
)

export default component.exports